import "core-js/stable";
import "regenerator-runtime/runtime";

import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@/assets/app.css";
import "@/components/_globals";
import "@/assets/github-markdown.css";
import "@/assets/app.css";
import "@/filters";

Vue.config.productionTip = false;

// Set up app wide read-only configs and install as plugin
import { myApp } from "./services/AppInit";
myApp.install = function () {
  Object.defineProperty(Vue.prototype, "$myApp", {
    get() {
      return myApp;
    },
  });
};
Vue.use(myApp);

import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

import { createProvider } from "./vue-apollo";
import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

import VueDummy from "vue-dummy";
Vue.use(VueDummy);

import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

// NProgress is bundled (not CDN-loaded). Expose it globally for the router guard
// and components that reference window.NProgress, and override the default
// template to drop the invalid role="bar"/role="spinner" ARIA roles (WCAG 4.1.2).
// The bar/spinner are purely decorative, so they are marked aria-hidden.
window.NProgress = NProgress;
NProgress.configure({
  // Drop the invalid role="bar"/role="spinner" ARIA roles (WCAG 4.1.2). NProgress
  // locates its own elements via barSelector/spinnerSelector (which default to
  // those roles), so repoint them at the .bar/.spinner classes the template keeps.
  template:
    '<div class="bar" aria-hidden="true"><div class="peg"></div></div>' +
    '<div class="spinner" aria-hidden="true"><div class="spinner-icon"></div></div>',
  barSelector: ".bar",
  spinnerSelector: ".spinner",
});

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: createProvider(),

  render: (h) => h(App),
}).$mount("#app");
